<template>

  <div class="mb-4" v-if="sf_demo_loan_info !== null && sfdcSearchEnabled() && ifUserCanAccess()">
    <!-- v-if="taskInfo !== null" -->
    <!--#region -- Content ---->

    <div class="stage-header mb-4">
      <div class="caption-label">
        Demo Loan
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <div class="header-col">
            <div>Demo ID</div>
            <gtc-account-link v-if=" sf_demo_loan_info!= null"
                              :opportunityId="sf_demo_loan_info.ID"
                              :opportunityName="_.get(sf_demo_loan_info, 'NAME', '')"
                              v-b-tooltip.hover.right :title="linkHoverInfo('Demo Loan')" />
          </div>
        </div>


        <!-- 1---------------------------------------------------------->
        <div class="col-6">
          <div class="header-col">
            <div>Owner</div>
            <div>{{ _.get(sf_demo_loan_info, 'OWNER_NAME', '') }}</div>
          </div>
          <div class="header-col">
            <div>Demo/Trial Group</div>
            <div>{{ _.get(sf_demo_loan_info, 'DEMO_TRIAL_GROUP__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Account</div>
            <div v-if="sf_account_info">
              <a class="link" target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${_.get(sf_account_info, 'ID', '') }`)">
                {{ _.get(sf_account_info, 'NAME', '') }}
              </a>
            </div>
          </div>
          <div class="header-col">
            <div>Opportunity</div>
            <div v-if="sf_opty_info">
              <a class="link"
                 target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ _.get(sf_demo_loan_info, 'OPPORTUNITY__C', '') }`)">
                {{ _.get(sf_opty_info, 'NAME', '') }}
              </a>
            </div>
          </div>
          <div class="header-col">
            <div>Opportunity Partner</div>
            <div>{{ _.get(sf_demo_loan_info, 'OPPORTUNITY_PARTNER__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Opportunity SA In-Charge</div>
            <div>{{ _.get(sf_demo_loan_info, 'OPPORTUNITY_SA_IN_CHARGE_NAME', '') }}</div>
          </div>

          <div class="header-col">
            <div>SA-In-Charge Email</div>
            <div>{{ _.get(sf_demo_loan_info, 'SA_IN_CHARGE_EMAIL__C', '') }}</div>
          </div>
        </div>

        <!-- 2---------------------------------------------------------->
        <div class="col-6">
          <div class="header-col">
            <div>Trial Type</div>
            <div>{{ _.get(sf_demo_loan_info, 'TRIAL_TYPE__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>HappyFox Ticket URL</div>
            <div v-if="_.get(sf_demo_loan_info, 'HAPPYFOX_TICKET_URL__C', '') !== null && (_.get(sf_demo_loan_info, 'HAPPYFOX_TICKET_URL__C', '')).includes('https://')">
              <a class="link"
                 target="_blank"
                 :href="sf_demo_loan_info.HAPPYFOX_TICKET_URL__C">
                {{ _.get(sf_demo_loan_info, 'HAPPYFOX_TICKET_URL__C', '') }}
              </a>
            </div>
            <div v-else>{{ _.get(sf_demo_loan_info, 'HAPPYFOX_TICKET_URL__C', '') }}</div>

          </div>
          <div class="header-col">
            <div>
              Sales Territory
            </div>
            <div>{{ _.get(sf_demo_loan_info, 'SALES_TERRITORY__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Status</div>
            <div>{{ _.get(sf_demo_loan_info, 'STATUS__C', '') }} {{ _.get(sf_account_info, 'ANNUALREVENUE', '') }}</div>
          </div>
          <div class="header-col">
            <div>
              Shipped Date
            </div>
            <div>{{ _.get(sf_demo_loan_info, 'SHIPPED_DATE__C', '') }}</div>
          </div>

          <div class="header-col">
            <div>
              Unit Returned Date
            </div>
            <!-- Actual received date of demo units. Mandatory when Status = 'Closed – Return Complete' -->
            <div>
              <button type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.topleft
                      title="Actual received date of demo units. Mandatory when Status = 'Closed – Return Complete'."></button>
              {{ _.get(sf_demo_loan_info, 'UNIT_RETURNED_DATE__C', '') }}
            </div>
          </div>

          <div class="header-col">
            <div>
              Request No
            </div>
            <div>{{ _.get(sf_demo_loan_info, 'REQUEST_NO__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>
              Loan Process Details
            </div>
            <div>{{ _.get(sf_demo_loan_info, 'LOAN_PROCESS_DETAILS__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Actual Loan Days</div>
            <div>{{ _.get(sf_demo_loan_info, 'ACTUAL_LOAN_DAYS__C', '') }}</div>
          </div>
        </div>

        <!-- 0---------------------------------------------------------->
        <!-- the 3rd columns: HIDDEN
              <div class="col-4">
      <div class="header-col">
        <div>Vertical</div>
        <div>{{ _.get(sf_account_info, 'SUB_VERTICAL_INDUSTRY__C', '') }}</div>
      </div>
    </div>-->

      </div>
      <!---  region: Factory Options May Require Lead Times of 45 - 60 Days INFO -->
      <div class="caption-label">
        Factory Options May Require Lead Times of 45 - 60 Days
      </div>
      <div class="row mb-4">
        <!-- 1---------------------------------------------------------->
        <div class="col-6">
          <div class="header-col">
            <div>
              Desired Receiving Date
            </div>
            <div>
              <button type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.topleft
                      title="Factory Options may require lead times of 45 – 60 days."></button>
              {{ _.get(sf_demo_loan_info, 'DESIRED_RECEIVING_DATE__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>Loan Period</div>
            <div>{{ _.get(sf_demo_loan_info, 'LOAN_PERIOD__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>
              Due Date
            </div>
            <div>
              <button type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.topleft
                      title="Calculated based on Desired Receiving Date + Loan Period."></button>
              {{ _.get(sf_demo_loan_info, 'DUE_DATE__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>Created By</div>
            <div>{{ _.get(sf_demo_loan_info, 'CREATEDBY_NAME', '') }}</div>
          </div>
        </div>

        <!-- 2---------------------------------------------------------->
        <div class="col-6">
          <div class="header-col">
            <div>
              Business Potential
            </div>
            <!-- Include qty, timeframe, application, and competitor -->
            <div>
              <button type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.topleft
                      title="Include qty, timeframe, application, and competitor."></button>
              {{ _.get(sf_demo_loan_info, 'BUSINESS_POTENTIAL__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>
              Demo Returned Responsibilities

              <!--  i.e. Product Disposition -->
            </div>
            <div>
              <button type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.topleft
                      title="i.e. Product Disposition."></button>
              {{ _.get(sf_demo_loan_info, 'DEMO_RETURNED_RESPONSIBILITIES__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>
              Outstanding Status

              <!-- If Due Date < Today and Status="Shipped" -> "Past Due" Otherwise -> "Current" -->
            </div>
            <div>
              <button type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.topleft
                      title="If Due Date < Today and Status='Shipped' -> 'Past Due' Otherwise -> 'Current'"></button>
              {{ _.get(sf_demo_loan_info, 'OUTSTANDING_STATUS__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>
              Last Modified By
            </div>
            <div>{{ _.get(sf_demo_loan_info, 'LASTMODIFIEDBY_NAME', '') }}</div>
          </div>
        </div>
      </div>

      <!-- region: Attachments -->
      <div class="stage-header mb-4">
        <div class="caption-label">
          Attachments
          <b-badge style="margin-left: 5px;"
                   v-if="sf_demo_loan_info !=null && sf_demo_loan_info.attachment_info_list != null && sf_demo_loan_info.attachment_info_list.content_document_info_list!=null" variant="primary">{{sf_demo_loan_info.attachment_info_list.content_document_info_list.length}}</b-badge>
          <b-badge style="margin-left: 5px; " v-else variant="primary">0</b-badge>
        </div>

        <b-table v-if="sf_demo_loan_info !=null && sf_demo_loan_info.attachment_info_list != null && sf_demo_loan_info.attachment_info_list.content_document_info_list!=null" :fields="attachmentFields" :items="sf_demo_loan_info.attachment_info_list.content_document_info_list"
                 small
                 thead-class="thead-light text-dark"
                 style="width: calc(100% - 10px)">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>
                Lo             *
                ading...
              </strong>
            </div>
          </template>
          <template #cell(file_title)="data">
            <!--
                  <button v-if="sfdcSearchEnabled() && ifUserCanAccess()
                            && data.item.version_data != null && data.item.content_document_id != null && data.item.file_title!=null"
                            type="button"
                            class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                            v-b-tooltip.hover title="Download Attachment python method"
                            @click="downloadDemoLoanAttachments(data.item.version_data, data.item.content_document_id, data.item.download_file_name, data.item.file_title, data.item.file_type)">
                    </button>

        -->

            <span>{{data.item.file_title}}.{{data.item.file_type}}</span>
            <button v-if="sfdcSearchEnabled() && ifUserCanAccess()
                    && data.item.version_data != null && data.item.content_document_id != null && data.item.file_title!=null"
                    type="button"
                    class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                    v-b-tooltip.hover title="Download Attachment"
                    @click="downloadDemoLoanAttachmentGetac(data.item.version_data, data.item.content_document_id, data.item.download_file_name, data.item.file_title, data.item.file_type)">
            </button>
          </template>
          <template #cell(file_size)="data">
            <span>{{data.item.file_size}} KB</span>

          </template>
        </b-table>
      </div>
      <!-- endregion-->
      <!-- region: ACCOUNT INFO BY REF COMPONETS-->
      <div>
        <account-page v-if="sf_account_info!=null && sfdcSearchEnabled()"
                      :prop_account_page_obj="sf_account_info"
                      :prop_user_sites="userSites"
                      :prop_user="login_user_name"
                      :prop_user_functions="userFunctions"
                      :prop_user_roles="userRoles" />
      </div>
      <!-- end region-->
      <!---  region: ACCOUNT INFO -->
      <!-- endregion -->
      <!-- region: Attachment Section -->
      <!-- endregion -->
      <!-- region: Opportunity Section -->
      <!-- endregion -->
      <!-- region: SalesForce Contact Loader -->
      <!-- endregion-->

    </div>

  </div>
  <div v-else-if="sf_demo_loan_info !== null && ifUserCanAccess() != true">
    <h3>{{`You do not have sufficient permissions to view Salesforce Demo Loan Information from this Region.\nPlease contact FTIE system administrators.`}}</h3>
  </div>
</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'demo-loan-page',
    props: {
      prop_demo_loan_page_obj: {
        default: null
      },
      prop_account_page_obj: {
        default: null
      },
      prop_opportunity_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
    },
    data() {
      return {
        function_name: 'Demo Loan Page',
        activeTab: 0,
        visible: false,
        taskInfo: null,
        sf_account_info: null,
        sf_contact_info: null,
        sf_demo_loan_info: null,
        sf_opty_info: null,
        demo_loan_id: encodeURIComponent(this.$route.params.demo_loan_id),
        date_from: null,
        account_id: encodeURIComponent(this.$route.params.account_id),
        opty_id: null,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        accountFields:[
          { key: 'OPPORTUNITY_NUMBER__C', label: 'Opportunity Number', thClass: 'align-middle', sortable: true },
          { key: 'OPPORTUNITY_NAME', label: 'Opportunity Name', thClass: 'align-middle', sortable: true },
          { key: 'STAGE', label: 'Stage', thClass: 'align-middle', sortable: true },
          { key: 'PROBABILITY', label: 'Probability', thClass: 'align-middle', sortable: true },
          { key: 'VERTICAL_INDUSTRY__C', label: 'Industry', thClass: 'align-middle', sortable: true },
          { key: 'OWNER_NAME', label: 'Owner', thClass: 'align-middle', sortable: true },
          { key: 'CREATEDDATE', label: 'Created Date', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'LASTMODIFIEDDATE', label: 'Lastmodified Date', thClass: 'align-middle', sortable: true }
        ],
        attachmentFields: [
          {
            key: 'file_title',
            label: 'Title',
            thClass: 'align-middle',
            tdClass: 'min-w-200',
            sortable: true
          },
          // { key: 'file_type', label: 'Type', thClass: 'align-middle', sortable: true },
          { key: 'file_size', label: 'Size', thClass: 'align-middle', sortable: true },
          { key: 'owner_name', label: 'Owner', thClass: 'align-middle', sortable: true },
          { key: 'create_by_name', label: 'Create By', thClass: 'align-middle', sortable: true },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle', sortable: true },
          { key: 'latest_update_date', label: 'Latest Update Date', thClass: 'align-middle', sortable: true }
        ],
        contactFields: [
          { key: 'NAME', label: 'Name', thClass: 'align-middle', sortable: true },
          { key: 'EMAIL', label: 'Email', thClass: 'align-middle', sortable: true },
          { key: 'PHONE', label: 'Phone', thClass: 'align-middle', sortable: true },
          { key: 'MOBILEPHONE', label: 'Mobile Phone', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'COUNTRY__C', label: 'Country', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGCOUNTRY', label: 'Mailing Country', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGPOSTALCODE', label: 'Postal Code', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGSTATE', label: 'Mailing State', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGCITY', label: 'Mailing City', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGSTREET', label: 'Mailing Street', thClass: 'align-middle', sortable: true },
          { key: 'CREATE_BY', label: 'Contact Create By', thClass: 'align-middle', sortable: true },
        ],
        //// //// ////
        missingData: 'N/A (Old data not found)',
        readOnly: false,
        access_to_opty: false,
      };
    },
    created() {
      let self = this;
      self.date_from = moment().format('YYYY-MMM-DD');
      self.userSites = self.prop_user_sites;
      self.login_user_name = self.prop_user;
      self.userRoles = self.prop_user_roles;
      self.checkLoggedIn();
      self.access_to_opty = self.sfdcSearchEnabled();

      if (self.sfdcSearchEnabled) {
        if (self.prop_demo_loan_page_obj == null) {
          self.getDemoLoanInfo();
        } else {
          self.sf_demo_loan_info = self.prop_demo_loan_page_obj;
          self.sf_account_info = self.prop_account_page_obj;
          self.sf_opty_info = self.prop_opportunity_page_obj;
          self.demo_loan_id = self.sf_demo_loan_info.ID;
          self.account_id = self.sf_account_info.ID;
          self.opty_id = self.sf_opty_info.ID;
        }
      } else {
        this.$message.error(`You do not have permissions to access Salesforce Demo Loan Information.\nPlease contact FTIE system administrators.`);
      }
     },

    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      linkHoverInfo(linkTo){
        return `View Salesforce ${linkTo} Page (Permission Required)`;
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

      },

      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },

      isShowingCollapseFunc(accordionId) {
        let self = this;
        return _.get(self.isShowingCollapse, accordionId, false);
      },

      // Toggle Both Collapse A and B (by IDS list)
      toggleCollapses(ids) {
        ids.forEach((id) => {
          this.$root.$emit('bv::toggle::collapse', id)
        })
      },
      getDemoLoanInfo() {
        // /opportunity/back-end/opty-id/<str:opty_id>
        // opportunity/back-end/demo-loan/demo-loan-id/<str:demo_loan_id>
        let self = this;

        let requestData = {
          demo_loan_id: self.demo_loan_id,
        };
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/opportunity/back-end/demo-loan/demo-loan-id/' + self.demo_loan_id, requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'demo_loan_info', null) !== null) {
              self.sf_demo_loan_info = JSON.parse(result.demo_loan_info);
            }
            if (_.get(result, 'account_info', null) !== null) {
              self.sf_account_info = JSON.parse(result.account_info);
              self.account_id = self.sf_account_info.ID;
            }
            if (_.get(result, 'opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.opty_info);
              self.opty_id = self.sf_opty_info.ID;
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (self.demo_loan_id !== null) {
              console.log("self.sf_demo_loan_info");
              console.log(self.sf_demo_loan_info);
              console.log("self.sf_account_info");
              console.log(self.sf_account_info);
              console.log("self.sf_opty_info");
              console.log(self.sf_opty_info);
            }

          });
      },
      
      onTabChange(newIndex) {
        console.log("newIndex:" + newIndex);
        let self = this;

      },


      downloadDemoLoanAttachmentGetac(docVersionId, docId, downloadFileName, docName, docType) {

        let self = this;
        let resultText = null;
        let purpose = docName;
        // let url = self.$root.baseUrl + '/salesforce-py/report/download/report-id/' + docId;
        //let url = self.$root.baseUrl + '/salesforce-py/content_document/download/doc-ver-id/' + docId;
        let url = self.$root.baseUrl + '/salesforce-py/content_document-getac/download/doc-ver-id/' + docId;
        console.log("purpose" + purpose);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();
        let request_data = {
          downloadTime: downloadTime,
          //download_purpose: purpose,
          version_link: docVersionId,
          content_document_id: docId,
          title: docName,
          file_extension: docType,
          download_file_name: downloadFileName,
          user_name: self.$session.get('user_name'),
          user_roles: self.$session.get('user_roles'),
          user_functions: self.$session.get('user_functions'),
          user_site: self.$session.get('user_site'),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.data) {
              // let content_result = res.data['Result'];
              let content_result = res.data;
              console.log("content_result:");
              console.log(content_result);
              const url = window.URL.createObjectURL(new Blob([content_result]));
              const link = document.createElement('a');
              console.log("url:");
              console.log(url);
              console.log("link:");
              console.log(link);
              // let fileName = res.data['filename']
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              // let file_name = docName + '_' + dateTimeStr + '.' + docType;
              console.log("downloadFileName =" + downloadFileName);
              link.setAttribute('download', downloadFileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },


      /*

      downloadDemoLoanAttachments(docVersionId, docId, downloadFileName, docName, docType) {

        let self = this;
        let resultText = null;
        let purpose = docName;
        let url = self.$root.baseUrl + '/salesforce-py/content_document/download/doc-ver-id/' + docId;
        console.log("purpose" + purpose);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();
        let request_data = {
          downloadTime: downloadTime,
          version_link: docVersionId,
          content_document_id: docId,
          title: docName,
          file_extension: docType,
          download_file_name: downloadFileName,
          user_name: self.$session.get('user_name'),
          user_roles: self.$session.get('user_roles'),
          user_functions: self.$session.get('user_functions'),
          user_site: self.$session.get('user_site'),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.data) {
              let content_result = res.data;
              console.log("content_result:");
              console.log(content_result);
              const url = window.URL.createObjectURL(new Blob([content_result]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              console.log("downloadFileName =" + downloadFileName);
              link.setAttribute('download', downloadFileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },

      */


      sfdcSearchEnabled() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1))  || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Search Enabled!!");
          return true
        }
        console.log("Search Disabled!!");
        // this.$message.error(`You do not have permissions to access Salesforce Account Information.\nPlease contact FTIE system administrators.`);
        return false;

      },
      ifUserCanAccess() {
        let self = this;
        console.log("ifUserCanAccess -- self.userSites:");
        console.log(self.userSites);
        console.log("ifUserCanAccess -- self.sf_account_info, 'COUNTRY__C', '')");
        console.log(_.get(self.sf_account_info, 'COUNTRY__C', ''));
        if (self.sfdcSearchEnabled()) {
          if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
          ) {
            return true
          }
          if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
            console.log("Can only view US opty for GUSA SA !!");
            if (_.get(self.sf_account_info, 'COUNTRY__C', '') === "United States") {
              return true
            }
            else {
              return false
            }
          }
        }
        return false;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/opty-management/DemoLoanPage.vue